<template>
  <div>
    <div class="mb-3">
      <div class="mb-3">
        <label for="google-maps" class="form-label">{{ $t('po_lc_lb_google_maps') }}*</label>
        <input id="google-maps" name="google-maps" type="text" class="form-control" :class="{ 'is-invalid': v$.locationDetails.googleMapsLink.$error }"
               :placeholder="$t('po_lc_tx_google_maps')" ref="password" v-model="locationDetails.googleMapsLink">
        <div class="invalid-feedback">{{ v$.locationDetails.googleMapsLink.$errors[0]?.$message }}</div>
      </div>
    </div>
    <div class="mb-3">
      <label for="phone" class="form-label">{{ $t('po_lc_lb_phone') }}*</label>
      <input id="phone" name="phone" type="text" class="form-control" :class="{ 'is-invalid': v$.locationDetails.phone.$error }"
        :placeholder="$t('po_lc_tx_phone')" ref="password" v-model="locationDetails.phone">
      <div class="invalid-feedback">{{ v$.locationDetails.phone.$errors[0]?.$message }}</div>
    </div>
    <div class="mb-3">
      <label for="homepage" class="form-label">{{ $t('po_lc_lb_homepage') }}*</label>
      <input id="homepage" name="homepage" type="text" class="form-control" :class="{ 'is-invalid': v$.locationDetails.homepage.$error }"
        :placeholder="$t('po_lc_tx_homepage')" ref="password" v-model="locationDetails.homepage">
      <div class="invalid-feedback">{{ v$.locationDetails.homepage.$errors[0]?.$message }}</div>
    </div>
    <div class="mb-3" v-if="moreDetails">
      <label for="facebook" class="form-label">{{ $t('po_lc_lb_facebook') }}</label>
      <input id="facebook" name="facebook" type="text" class="form-control" :class="{ 'is-invalid': v$.locationDetails.facebook.$error }"
        :placeholder="$t('po_lc_tx_facebook')" ref="password" v-model="locationDetails.facebook">
      <div class="invalid-feedback">{{ v$.locationDetails.facebook.$errors[0]?.$message }}</div>
    </div>
    <div class="mb-3" v-if="moreDetails">
      <label for="twitter" class="form-label">{{ $t('po_lc_lb_twitter') }}</label>
      <input id="twitter" name="twitter" type="text" class="form-control" :class="{ 'is-invalid': v$.locationDetails.twitter.$error }"
        :placeholder="$t('po_lc_tx_twitter')" ref="password" v-model="locationDetails.twitter">
      <div class="invalid-feedback">{{ v$.locationDetails.twitter.$errors[0]?.$message }}</div>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, url } from '@/config/i18n-validators'

export default {
  props: {
    modelValue: Object,
    moreDetails: Boolean
  },
  components: {
  },
  setup () {
    return {
      v$: useVuelidate({ $autoDirty: true })
    }
  },
  validations () {
    return {
      locationDetails: {
        googleMapsLink: { required, url },
        phone: { required },
        homepage: { required, url },
        facebook: { },
        twitter: { }
      }
    }
  },
  computed: {
    locationDetails: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit('update:modelValue', val)
      }
    }
  }
}
</script>
